module.exports = __webpack_public_path__ + "img/floodlight_pairing_mode.ceaabdaf.png";